import ajax from 'api/ajax';
class findMSDS {
    // 获取化学品的列表tab
    getMSDSList = (per_page, page, key) => ajax('dict-msds/search', { 'per-page': per_page, page, key }, 'get');
    // 获取规格
    //     excel导入试剂 生成库存
    GenerateInventory = () => ajax('chem-storage-tmp/sync', {}, 'post');
    // getTmpInfo
    getTmpInfo = () => ajax('chem-v-storage-tmp/info', {}, 'get');
    //    导出数据chem-v-storage-tmp/export
    exportData = () => ajax('chem-v-storage-tmp/export', {}, 'get');
    //   点击清空数据 chem-storage-tmp/delete
    clearTmp = () => ajax('chem-storage-tmp/delete', {}, 'post');
    //dict-msds/info msds详情
    msdsInfo = chemid => ajax('dict-msds/info', { chemid }, 'get');
}
export default findMSDS;
